import React, { useState } from 'react';
import MiniUserDetail from '../MiniUserDetail/MiniUserDetail';
import cx from 'classnames';
import styles from './CommentsApprovals.module.scss';
import DeleteApprovalsCommentModal from '../DeleteApprovalsCommentModal/DeleteApprovalsCommentModal';
import { timeSinceShort } from '../../utils/TimeUtil';
import { useTranslation } from 'react-i18next';
import EditApprovalsCommentModal from '../EditApprovalsCommentModal/EditApprovalsCommentModal';
import { parseString } from '../../utils/stringHelper';

const CommentsApprovals = ({ comment, user, handleDeleteComment, handleEditComment, storyAuthor, isFirstComment }) => {
  const [isShowDeleteModal, setIsShowDeleteModal] = useState(false);
  const [isShowEditModal, setIsShowEditModal] = useState(false);

  const { t } = useTranslation();

  return (
    <div>
      <div className={styles.line} />
      <div className={styles.commentContainer}>
        <div className={styles.userDetails}>
          <MiniUserDetail avatar={user?.avatar} size="medium" oneLetterAcronym={false} name={parseString(comment.authorName)} />
          <span className={styles.elapsedTime}>{timeSinceShort(comment.date)}</span>
        </div>
        <div className={styles.commentbody}>
          <div className={cx(styles.commentContent, { [styles.firstCommentContent]: isFirstComment })}>
            {parseString(comment.content).replace(/<br\s*[\/]?>/gi, '\n')}
          </div>
          {user && user.username === storyAuthor?.username && (
            <div className={styles.commentActions}>
              <span className={styles.btn} onClick={() => setIsShowDeleteModal(true)}>
                {t('general.delete')}
              </span>
              <span className={styles.btn} onClick={() => setIsShowEditModal(true)}>
                {t('general.edit')}
              </span>
            </div>
          )}
        </div>
        {isShowDeleteModal && (
          <DeleteApprovalsCommentModal
            isShow={isShowDeleteModal}
            onClose={() => setIsShowDeleteModal(false)}
            confirmDeletion={() => handleDeleteComment(comment.id)}
          />
        )}
        {isShowEditModal && (
          <EditApprovalsCommentModal
            isShow={isShowEditModal}
            onClose={() => setIsShowEditModal(false)}
            handleEditComment={handleEditComment}
            initialComment={comment}
          />
        )}
      </div>
    </div>
  );
};

export default CommentsApprovals;
